<template>
  <div>
   <IntroText v-if="pageItem.ShortText" :intro-one="pageItem.ShortText" :pageItem="pageItem" />
    <v-alert v-if="errorString" type="error" dense>
      <div class="d-flex align-center justify-space-between">
        <span>{{ errorString }}</span>
        <v-btn small @click="reloadPage" color="white" text>
          <v-icon small left>mdi-refresh</v-icon>
          {{ dataAll.getStatic('product_loading_error_reload', 'Reload page') }}
        </v-btn>
      </div>
    </v-alert>
    <v-overlay
      :model-value="loading"
      persistent
      scroll-strategy="none" 
      content-class="loading-content-force"
      class="align-center justify-center"
    >
      <div class="text-center pa-6 bg-white rounded elevation-8">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
          class="spinner-force"
        ></v-progress-circular>
        <div class="mt-4 text-h6">
          {{ dataAll.getStatic('product_loading_text', 'Loading...') }}
        </div>
      </div>
    </v-overlay>

    <v-container fluid class="ProductItemOverview"
    
     v-if="pageItem.Selector && pageItem.Selector[2]&& pageItem.Selector[2].Selectors">
        <v-container>
       
        <v-row
        class="pa-0 position-sticky stickyfilter"
        >
          <!--hide on screens wider than md-->
          <v-col cols="12" class="d-md-none pa-0">
            <v-btn block

            color="primary"
            @click="setFilterMobile(false)">
              <v-icon start>mdi-filter-variant</v-icon>
            {{ showFilters ? dataAll.getStatic('product_filter_hide_button_mobile', "Hide filters") : dataAll.getStatic('product_filter_show_button_mobile', "Show filters") }}
            </v-btn>
          </v-col>

          <v-col cols="12"
          class="pa-0 mb-3"
          >
            <SelectorFilters   
              :pagData="pagData" 
              :selectors="pageItem.Selector[2].Selectors">
            </SelectorFilters>
          </v-col>
        </v-row> 
        <v-row
        class="py-0">
          <!-- Filter sidebar: full width on mobile, 3 cols on desktop -->
          <v-col cols="12"  md="3" lg="3" xl="2" xxl="3"
           :class="{ 'd-none d-md-block': !showFilters }"
           class=" h-100 pa-0"
          >
            <ProductOverviewSelector 
              v-if="pageItem" 
              :selectors="pageItem.Selector[2].Selectors" 
              :pageItem="pageItem" 
              :pagData="pagData" 
            />
          </v-col>
          
          <!-- Results: full width on mobile, 9 cols on desktop -->
          <v-col cols="12"
          md="9" lg="9" xl="10" xxl="9"
          class="pa-0"
          >
            <ProductOverviewResults 
              v-if="pageItem" 
              :header="pageItem.Selector[0].Header" 
              :pageItem="pageItem" 
              :pagData="pagData"
              class="pt-0
              "
            />
          </v-col>
        </v-row> 
      </v-container>
    </v-container>

    <IntroText  v-if="pageItem.MainText" :intro-one="pageItem.MainText" :pageItem="pageItem" />
    </div>
</template>
<style scoped>
  .stickyfilter {
  z-index: 100;
  top: 85px;
  }

  /* patch to force spinner to run */
  .spinner-force {
    animation: v-progress-circular-rotate 1.4s linear infinite !important;
  }

  @keyframes v-progress-circular-rotate {
    to {
      transform: rotate(360deg);
    }
  }
  :deep(.loading-content-force) {
    opacity: 1 !important;
    z-index: 1 !important;
  } 
</style>



<script setup>
import IntroText from "@/components/Base/introText.vue";
import ProductOverviewSelector from "@/components/Products/PAG/ProductOverviewSelector.vue";
import ProductOverviewResults from "@/components/Products/PAG/ProductOverviewResults.vue";
import Downloads from "@/components/Base/downloads.vue";
import SelectorFilters from "@/components/Products/PAG/SelectorControls/SelectorFilters.vue";
import { onBeforeUnmount, onBeforeMount, onMounted, nextTick, ref } from 'vue';

const { mobile, xs, mdAndUp  } = useDisplay();
const dataAll = useDataAll();
const showFilters = ref();

const props = defineProps({
  pageItem: {
    type: Object,
    default: "",
  },
});

const route = useRoute();
const errorString = computed(() => dataAll.getDataVar('errorStringLoadPAG'));
const isClientNavigation = import.meta.client
const { $PAG, $methods } = useNuxtApp()
const pagData = ref({ products: [] });
const loading = ref(false);
const error = ref(null);

onMounted(async() => {

  setFilterMobile(true)
  // save last PAG url for return button shopping
  sessionStorage.setItem('lastPAGUrl', route.fullPath)

  if (isClientNavigation) {
    await loadData();
  }
})

const fetchPagData = async () => {
  if (!props.pageItem?.Selector) {
    return { products: [] };
  }
  
  try {
   
    const response = await $PAG.pagApiCall(props.pageItem);
    if (response?.error || !response) {
      throw new Error(response.error);
    }
    PAGResetError();
    return response || { products: [] };
  } catch (err) {
    PAGSetError(dataAll.getStatic('product_loading_text', 'Error while loading. Please try again later or reload the page'));
    if (err.response?.status !== 404) {
      $methods.logError("Error during api call::" + err);
    }
    return { products: [] };
  }
};

const loadData = async () => {
  loading.value = true;
  try {
    pagData.value = await fetchPagData();
  } catch (e) {
    error.value = e;
  } finally {
    loading.value = false;
  }
};

// Server-side
if (import.meta.server) {
  loading.value = true;
  pagData.value = await fetchPagData();
  loading.value = false;
}



// Server-side
if (import.meta.server) {
  loading.value = true;
  pagData.value = await fetchPagData();
  loading.value = false;
}
// Error handling
watch(error, (newError) => {

  if (newError) {
    PAGSetError(newError.message || dataAll.getStatic('product_loading_text', 'Error while loading. Please try again later or reload the page'))
    dataAll.setDataVar('errorStringLoad', '') //reset error Ourrouter
  } 
});

function setFilterMobile(init){
  if (import.meta.client){
    // showFilters.value = true;
    const STORAGE_KEY_FILTER = 'showPAGFilterMobile';
    // On PC or tablet always show 
    if (mdAndUp.value) {
      showFilters.value = false;
      localStorage.setItem(STORAGE_KEY_FILTER, showFilters.value);
      return;
    }

    if (!init){
      showFilters.value = !showFilters.value
    } else {
      const localStorageValue = localStorage.getItem(STORAGE_KEY_FILTER)
      showFilters.value = localStorageValue === 'false' ? false : true;
      
    }
    localStorage.setItem(STORAGE_KEY_FILTER, showFilters.value);
  }
}
function reloadPage(){
  window.location.reload();
}
function PAGResetError(){
  dataAll.setDataVar('errorStringLoadPAG', '')
  errorString.value = ''
}
function PAGSetError(errorStringIn){
  dataAll.setDataVar('errorStringLoadPAG', errorStringIn)
  dataAll.setDataVar('errorStringLoad', '') //reset error Ourrouter
  errorString.value = errorStringIn
}

</script>
